import { useNavigate, useLocation } from 'react-router-dom';
import { useSidebar } from '../context/SidebarContext';
import React, { useState, useEffect } from 'react';
import agentConfigs from '../agentConfigs';
import home from '../assets/home.png';
import newspaper from '../assets/newspaper.png'
import ai from '../assets/ai.png';
import user from '../assets/user.png';
import exit from '../assets/exit.png';
import drive from '../assets/drive.png';
import folder from '../assets/folder.png';;


const Sidebar = () => {
    const isMobile = window.innerWidth <= 767
    const SIDEBAR_WIDTH = isMobile ? '50vw' : '15vw'
    const navigate = useNavigate()
    const location = useLocation();
    const { sidebarOpen, toggleSidebar, closeSidebar } = useSidebar()
    const isAdmin = localStorage.getItem('is_admin') === 'true'
    const [hamburgerHovered, setHamburgerHovered] = useState(false);


    const agents = agentConfigs.filter(a => !a.adminOnly || isAdmin)

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('is_admin');
        localStorage.removeItem('lastChatId');
        navigate('/');
        closeSidebar();
    };

    const [projects, setProjects] = useState([]);

    useEffect(() => {
        const fetchProjects = async () => {
            const token = localStorage.getItem('token') || sessionStorage.getItem('token');
            try {
                const res = await fetch('https://hubdaive.com.br/api/projects', {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                const data = await res.json();
                setProjects(Array.isArray(data) ? data : []);
            } catch {}
        };
        fetchProjects();
    }, []);

    const navItem = (label,icon, path) => {
        const isActive = location.pathname === path;
        return (
            <div
                onClick={() => { navigate(path); closeSidebar(); }}
                style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '10px 16px',
                borderRadius: '8px',
                cursor: 'pointer',
                backgroundColor: isActive ? '#1e1e1e' : 'transparent',
                border: isActive ? '1px solid #333' : '1px solid transparent',
                transition: 'background 0.15s',
                color: '#fff',
                }}
                onMouseEnter={e => { if (!isActive) e.currentTarget.style.backgroundColor = '#1a1a1a'; }}
                onMouseLeave={e => { if (!isActive) e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
                <img src={icon} style={{ width: '18px', height: '18px', filter: 'invert(100%)', flexShrink: 0 }} alt={label} />
                <span style={{ fontSize: '1.4vh', fontWeight: '500', whiteSpace: 'nowrap' }}>{label}</span>
            </div>
            );
        };
        
        return (
            <>
            <style>{`
            .hamburger-line {
                width: 20px !important;
                height: 2px !important;
            }

            @media (max-width: 767px) {
                .sidebar-label {
                font-size: 14px !important;
                }
                .sidebar-section-title {
                font-size: 11px !important;
                }
            }
            `}</style>
            {/* Botão hamburguer — sempre visível */}
            <button
                onClick={toggleSidebar}
                style={{
                position: 'fixed',
                top:'3.5%',
                left: '1%',
                zIndex: 2000,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                gap: '5px',
                padding: '8px',
                borderRadius: '8px',
                transition: 'background 0.15s',
                }}
                onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f0f0f0'; setHamburgerHovered(true); }}
                onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; setHamburgerHovered(false); }}
            >
                <span className="hamburger-line" style={{ display: 'block', width: '1vw', height: '0.2vh', backgroundColor: (!hamburgerHovered) ? '#fff' : '#000', borderRadius: '2px', transition: 'transform 0.2s', transform: sidebarOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }} />
                <span className="hamburger-line" style={{ display: 'block', width: '1vw', height: '0.2vh', backgroundColor: (!hamburgerHovered) ? '#fff' : '#000', borderRadius: '2px', opacity: sidebarOpen ? 0 : 1, transition: 'opacity 0.2s' }} />
                <span className="hamburger-line" style={{ display: 'block', width: '1vw', height: '0.2vh', backgroundColor: (!hamburgerHovered) ? '#fff' : '#000', borderRadius: '2px', transition: 'transform 0.2s', transform: sidebarOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }} />
            </button>
        
            {/* Sidebar */}
            <div  
                style={{
                position: 'fixed',
                top: 0,
                left: 0,
                height: '100vh',
                width: sidebarOpen ? SIDEBAR_WIDTH : '0px',
                backgroundColor: '#0d0d0d',
                borderRight: sidebarOpen ? '1px solid #222' : 'none',
                zIndex: 1500,
                overflow: 'hidden',
                transition: 'width 0.25s ease',
                display: 'flex',
                flexDirection: 'column',
            }}>
                {/* Topo */}
                <div style={{ height: '4vh', flexShrink: 0 }} />
        
                {/* Nav principal */}
                <div style={{ padding: '0 12px', flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
                <p className="sidebar-section-title" style={{ color: '#555', fontSize: '1.5vh', fontWeight: 'bold', letterSpacing: '1px', padding: '0 16px', marginBottom: '8px', marginTop: '5vh' }}>NAVEGAÇÃO</p>
                {navItem('Início', home, '/home')}
                <p className="sidebar-section-title" style={{ color: '#555', fontSize: '1.5vh', fontWeight: 'bold', letterSpacing: '1px', padding: '0 16px', margin: '20px 0 8px' }}>NOTÍCIAS</p>
                {navItem('Notícias', newspaper, '/news')}
        
                <p className="sidebar-section-title" style={{ color: '#555', fontSize: '1.5vh', fontWeight: 'bold', letterSpacing: '1px', padding: '0 16px', margin: '20px 0 8px' }}>PROJETOS</p>
                {projects.map(project => {
                    const agent = agentConfigs.find(a => a.key === project.agent_type);
                    return (
                        <div
                            key={project.id}
                            onClick={() => { navigate(`/projects/${project.id}`); closeSidebar(); }}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '10px 16px',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                border: location.pathname === `/projects/${project.id}` ? `1px solid ${agent?.color || '#333'}33` : '1px solid transparent',
                                backgroundColor: location.pathname === `/projects/${project.id}` ? (agent?.color || '#007AFF') + '11' : 'transparent',
                                transition: 'background 0.15s',
                            }}
                            onMouseEnter={e => { if (location.pathname !== `/projects/${project.id}`) e.currentTarget.style.backgroundColor = '#1a1a1a'; }}
                            onMouseLeave={e => { if (location.pathname !== `/projects/${project.id}`) e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                            <img src={folder} alt="folder" style={{ width: 'auto', height: '1.5vh', filter: 'invert(100%)', flexShrink: 0 }} />
                            <span className="sidebar-section-title" style={{ fontSize: '1.5vh', fontWeight: '500', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {project.name}
                            </span>
                        </div>
                    );
                })}

                <p style={{ color: '#555', fontSize: '1.5vh', fontWeight: 'bold', letterSpacing: '1px', padding: '0 16px', margin: '20px 0 8px' }}>AGENTES</p>
                {agents.map(agent => (
                    <div
                    key={agent.key}
                    onClick={() => { navigate(`/chat/${agent.key}`); closeSidebar(); }}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '10px 16px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        border: location.pathname === `/chat/${agent.key}` ? `1px solid ${agent.color}33` : '1px solid transparent',
                        backgroundColor: location.pathname === `/chat/${agent.key}` ? agent.color + '11' : 'transparent',
                        transition: 'background 0.15s',
                    }}
                    onMouseEnter={e => { if (location.pathname !== `/chat/${agent.key}`) e.currentTarget.style.backgroundColor = '#1a1a1a'; }}
                    onMouseLeave={e => { if (location.pathname !== `/chat/${agent.key}`) e.currentTarget.style.backgroundColor = 'transparent'; }}
                    >
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: agent.color, flexShrink: 0 }} />
                    <div>
                        <div style={{ fontSize: '1.5vh', fontWeight: '500', color: '#fff', whiteSpace: 'nowrap',marginBottom: '1vh' }}>{agent.name}</div>
                        <div style={{ fontSize: '1.3vh', color: '#666', whiteSpace: 'nowrap' }}>{agent.tagline}</div>
                    </div>
                    </div>
                ))}
                
                {/* DONT DELETE */}
                {/* <p
                style={{ color: '#555', fontSize: '1.1vh', fontWeight: 'bold', letterSpacing: '1px', padding: '0 16px', margin: '20px 0 8px' }}>DRIVE</p>
                {navItem('Busca Drive', drive, '/home')} */}
                
                <p
                    onClick={() => alert('Ainda não implementado.')}
                    style={{ color: '#555', fontSize: '1.5vh', fontWeight: 'bold', letterSpacing: '1px', padding: '0 16px', margin: '20px 0 8px' }}>
                    DRIVE
                    </p>
                    <div
                    onClick={() => alert('Ainda não implementado.')}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        cursor: 'pointer',
                        padding: '10px 16px',
                        borderRadius: '8px',
                        opacity: 0.4,
                        border: '1px solid transparent',
                    }}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#1a1a1a'}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                    <img src={drive} style={{ width: '18px', height: '18px', filter: 'invert(100%)', flexShrink: 0 }} alt="Drive" />
                    <span style={{ fontSize: '1.4vh', fontWeight: '500', color: '#fff', whiteSpace: 'nowrap' }}>Busca Drive</span>
            </div>
            
            </div>
        
                {/* Rodapé — perfil */}
                <div style={{ padding: '12px', borderTop: '1px solid #1a1a1a' }}>
                {navItem('Perfil', user, '/profile')}
                <div
                        onClick={handleLogout}
                        style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '10px 16px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        border: '1px solid transparent',
                        transition: 'background 0.15s',
                        color: '#ff4444',
                        }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#1a1a1a'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        <img src={exit} style={{ width: '18px', height: '18px', filter: 'invert(30%) sepia(100%) saturate(500%) hue-rotate(300deg)', flexShrink: 0 }} alt="Sair" />
                        <span style={{ fontSize: '1.4vh', fontWeight: '500', whiteSpace: 'nowrap' }}>Sair</span>
                    </div>
                </div>
            </div>
            </>
        );
    };
 
export default Sidebar;
